import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2317 2317"
      id="vector">
      <g
        id="group"
        transform="translate(119 164)">
        <path
          id="path"
          d="M 525.5 7 L 524.5 9 L 525.5 7 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1285.5 242 L 1289.5 247 L 1285.5 242 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 403.5 354 L 402.5 356 L 403.5 354 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1644.5 359 L 1646.5 362 L 1644.5 359 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 392.5 365 L 391.5 367 L 392.5 365 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 449.5 410 L 447.5 413 L 449.5 410 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 1951.5 865 L 1952.5 867 L 1951.5 865 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1961.5 875 L 1962.5 877 L 1961.5 875 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 1906.5 920 L 1909.5 924 L 1906.5 920 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1991.5 1175 L 1994.5 1179 L 1991.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 1906.5 1264 L 1908.5 1267 L 1906.5 1264 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 809.5 1297 L 810.5 1299 L 809.5 1297 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 1231.5 1299 L 1227.5 1304 L 1231.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1957.5 1322 L 1959.5 1325 L 1957.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 1960.5 1372 L 1956.5 1377 L 1960.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1446.5 1504 L 1449.5 1508 L 1446.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 1449.5 1555 L 1445.5 1560 L 1449.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 560.5 1649 L 556.5 1654 L 560.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 1481.5 1705 L 1480.5 1707 L 1481.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1517.5 1794 L 1518.5 1796 L 1517.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 519.5 1846 L 520.5 1848 L 519.5 1846 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 522.5 1849 L 524.5 1852 L 522.5 1849 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1741.5 1992 L 1740.5 1994 L 1741.5 1992 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1738.5 1995 L 1737.5 1997 L 1738.5 1995 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 544.5 0 L 1315.5 0 L 1320.5 1 L 1335.5 8 L 1524 196.5 L 1531 211.5 L 1531 328 L 1582.5 329 L 1600.5 333 Q 1633.4 344.1 1653 368.5 L 1667 390.5 L 1674 409.5 L 1677 424.5 L 1677 839 L 1890.5 839 L 1910.5 843 L 1932.5 852 Q 1948.8 861.2 1961 874.5 Q 1976 890.5 1984 913.5 L 2060 1144.5 Q 2067.7 1153.8 2072 1166.5 L 2078 1190.5 L 2078 1684.5 Q 2074.6 1699.6 2063.5 1707 L 2056.5 1711 L 2043.5 1714 L 1667 1714.5 L 1749 1958.5 Q 1751.3 1965.2 1750 1975.5 L 1746 1986.5 L 1740 1995 L 1731.5 2001 L 1720.5 2005 L 321.5 2005 Q 307.6 2001.4 300 1991.5 Q 291.6 1982.9 292 1965.5 L 294 1956.5 L 375 1714 L 35.5 1714 Q 34 1711.5 28.5 1713 L 18.5 1709 L 8 1699.5 Q 2.9 1693.7 1 1684.5 L 1 1189.5 L 4 1175.5 L 10 1159.5 L 10 1155.5 L 25 1092.5 L 25 1088.5 L 27 1083.5 L 27 1079.5 L 29 1074.5 L 29 1070.5 L 31 1065.5 L 31 1061.5 L 33 1056.5 L 33 1052.5 L 35 1047.5 L 35 1043.5 L 37 1038.5 L 37 1034.5 L 39 1029.5 L 39 1025.5 L 41 1020.5 L 41 1016.5 L 43 1011.5 L 43 1007.5 L 45 1002.5 L 63 918.5 Q 73.6 884.1 98.5 864 Q 110.6 853.6 126.5 847 L 137.5 843 L 158.5 839 L 365 839 L 365 430.5 L 366 429.5 L 366 421.5 L 368 411.5 L 376 389.5 Q 385.9 369.9 401.5 356 Q 419.4 339.9 445.5 332 L 460.5 329 L 473.5 329 L 474.5 328 L 511 328 L 511 31.5 Q 513.8 16.8 523.5 9 L 535.5 2 L 544.5 0 Z M 583 73 L 583 839 L 1459 839 L 1459 255 L 1308 255 Q 1298 254 1293 249 Q 1281 241 1277 226 L 1277 74 L 1277 73 L 583 73 Z M 1350 124 L 1349 183 L 1407 183 L 1407 182 L 1350 124 Z M 469 401 Q 457 403 450 410 Q 441 417 438 430 L 438 839 L 439 839 L 511 839 L 511 402 L 511 401 L 469 401 Z M 1532 401 L 1532 839 L 1533 839 L 1605 839 L 1605 433 Q 1603 422 1598 416 Q 1590 405 1575 401 L 1532 401 Z M 166 911 L 154 914 L 147 918 Q 136 925 132 940 L 108 1052 L 106 1057 L 106 1061 L 104 1066 L 104 1070 L 102 1075 L 102 1079 L 100 1084 L 100 1088 L 98 1093 L 99 1094 L 1969 1094 L 1916 933 L 1910 924 Q 1904 917 1895 913 L 1885 911 L 166 911 Z M 101 1167 L 87 1173 L 76 1185 L 76 1191 L 73 1198 L 73 1641 L 74 1641 L 219 1641 L 219 1238 L 222 1226 L 226 1219 Q 234 1208 249 1204 L 1795 1204 L 1811 1212 Q 1820 1220 1823 1234 L 1823 1641 L 2006 1641 L 2004 1197 Q 2002 1185 1995 1179 Q 1988 1170 1976 1167 L 101 1167 Z M 292 1276 L 292 1532 L 435 1532 L 449 1489 L 449 1486 L 439 1473 L 436 1461 L 436 1420 L 439 1408 L 444 1400 Q 452 1389 467 1386 L 1573 1386 Q 1583 1388 1590 1394 Q 1600 1403 1603 1420 L 1603 1461 Q 1601 1462 1602 1467 Q 1599 1479 1590 1486 Q 1595 1509 1604 1530 L 1605 1532 L 1751 1532 L 1751 1276 L 1240 1276 Q 1240 1289 1234 1297 L 1222 1308 L 1212 1312 Q 1205 1310 1204 1313 L 840 1313 L 839 1312 L 828 1311 L 817 1305 Q 806 1297 803 1283 Q 804 1276 803 1276 L 292 1276 Z M 538 1458 L 536 1460 L 379 1933 L 1664 1933 L 1506 1461 L 1506 1458 L 538 1458 Z M 292 1604 L 292 1641 L 400 1641 L 412 1606 L 412 1604 L 292 1604 Z M 1631 1604 L 1640 1640 L 1642 1641 L 1751 1641 L 1751 1605 L 1751 1604 L 1631 1604 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1928.5 1204 L 1937.5 1204 L 1945.5 1206 Q 1955.2 1209.3 1961 1216.5 L 1968 1229.5 L 1969 1245.5 Q 1965.5 1261 1954.5 1269 Q 1945.5 1276.5 1928.5 1276 Q 1911.4 1272.6 1903 1260.5 L 1897 1246.5 L 1897 1232.5 Q 1900.6 1218.6 1910.5 1211 L 1917.5 1207 L 1928.5 1204 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 1924.5 1314 Q 1936.6 1312.4 1944.5 1315 Q 1956.4 1319.1 1963 1328.5 L 1969 1343.5 L 1969 1354.5 Q 1965.5 1371 1953.5 1379 L 1939.5 1385 L 1926.5 1385 Q 1912.5 1382 1905 1372.5 L 1897 1356.5 L 1897 1341.5 Q 1900.1 1329.1 1908.5 1322 L 1924.5 1314 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 617.5 1495 L 1425.5 1495 Q 1443.5 1498 1452 1510.5 Q 1458.9 1518.6 1459 1533.5 L 1454 1549.5 L 1442.5 1562 L 1434.5 1566 L 1425.5 1568 L 616.5 1568 Q 600.1 1565.4 592 1554.5 Q 582.8 1545.7 584 1526.5 Q 586.9 1510.9 597.5 1503 L 603.5 1499 L 617.5 1495 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 579.5 1641 L 1463.5 1641 Q 1479.9 1644.1 1488 1655.5 Q 1496.1 1664.4 1495 1682.5 Q 1492.2 1697.2 1482.5 1705 L 1470.5 1712 L 1460.5 1714 L 581.5 1714 L 565.5 1709 L 554 1698.5 L 548 1685.5 L 548 1669.5 Q 552.3 1654.8 563.5 1647 Q 570 1642.5 579.5 1641 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 542.5 1787 L 1500.5 1787 Q 1515.2 1789.8 1523 1799.5 L 1529 1809.5 L 1532 1823.5 L 1528 1839.5 L 1517.5 1852 Q 1511.7 1857.2 1502.5 1859 L 539.5 1859 L 529.5 1855 L 521 1849 L 513 1835.5 L 511 1828.5 L 511 1818.5 Q 514.1 1802.1 525.5 1794 Q 532.1 1788.6 542.5 1787 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 1335.5 7 L 1336.5 9 L 1335.5 7 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 523.5 8 L 519.5 13 L 523.5 8 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1276.5 73 L 1277 222.5 L 1276 222.5 L 1276.5 73 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1349 125 L 1350.5 125 L 1407 181.5 L 1350 126.5 L 1349.5 182 L 1349 125 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 1523.5 195 L 1524.5 197 L 1523.5 195 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1282.5 239 L 1283.5 241 L 1282.5 239 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1310.5 255 L 1459 255.5 L 1310.5 256 L 1310.5 255 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 463.5 328 L 467 328.5 L 463.5 329 L 463.5 328 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 1576.5 328 L 1579 328.5 L 1576.5 329 L 1576.5 328 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1633.5 349 L 1634.5 351 L 1633.5 349 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 406.5 351 L 405.5 353 L 406.5 351 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1638.5 353 L 1640.5 356 L 1638.5 353 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 400.5 356 L 393.5 364 L 400.5 356 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 1650.5 365 L 1652.5 368 L 1650.5 365 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 389.5 368 L 388.5 370 L 389.5 368 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1655.5 371 L 1656.5 373 L 1655.5 371 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 470.5 401 L 473 401.5 L 470.5 402 L 470.5 401 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 1570.5 401 L 1573 401.5 L 1570.5 402 L 1570.5 401 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 451.5 409 L 450.5 411 L 451.5 409 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 1592.5 410 L 1595.5 414 L 1592.5 410 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 447.5 413 L 445.5 416 L 447.5 413 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 1597.5 416 L 1598.5 418 L 1597.5 416 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 365.5 424 L 366 426.5 L 365 426.5 L 365.5 424 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 1677.5 428 L 1678 432.5 L 1677 432.5 L 1677.5 428 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 1604.5 434 L 1605 837.5 L 1603.5 839 L 1532.5 839 L 1532.5 838 L 1603.5 838 L 1604 837.5 L 1604.5 434 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 165.5 838 L 365 838.5 L 165.5 839 L 165.5 838 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 438.5 838 L 511 838.5 L 438.5 839 L 438.5 838 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 584.5 838 L 1459 838.5 L 584.5 839 L 584.5 838 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 1678.5 838 L 1883 838.5 L 1678.5 839 L 1678.5 838 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 1893.5 839 L 1896 839.5 L 1893.5 840 L 1893.5 839 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 106.5 857 L 105.5 859 L 106.5 857 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1947.5 861 L 1948.5 863 L 1947.5 861 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 98.5 863 L 95.5 867 L 98.5 863 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1954.5 867 L 1961.5 875 L 1954.5 867 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 86.5 875 L 84.5 878 L 86.5 875 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 1965.5 879 L 1966.5 881 L 1965.5 879 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 81.5 881 L 80.5 883 L 81.5 881 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1968.5 883 L 1969.5 885 L 1968.5 883 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 144.5 920 L 140.5 925 L 144.5 920 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 1910.5 925 L 1911.5 927 L 1910.5 925 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1989.5 1174 L 1990.5 1176 L 1989.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 84.5 1175 L 80.5 1180 L 84.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 0.5 1193 L 1 1195.5 L 0 1195.5 L 0.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 2078.5 1193 L 2079 1196.5 L 2078 1196.5 L 2078.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 2003.5 1197 L 2004 1199.5 L 2003 1199.5 L 2003.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 73.5 1199 L 74 1640.5 L 73 1640.5 L 73.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1790.5 1203 L 1793 1203.5 L 1790.5 1204 L 1790.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 233.5 1210 L 232.5 1212 L 233.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1810.5 1211 L 1814.5 1216 L 1810.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 1909.5 1211 L 1908.5 1213 L 1909.5 1211 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1957.5 1212 L 1960.5 1216 L 1957.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 227.5 1216 L 226.5 1218 L 227.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 1904.5 1216 L 1903.5 1218 L 1904.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1896.5 1234 L 1897 1236.5 L 1896 1236.5 L 1896.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 1823.5 1235 L 1824 1640.5 L 1823 1640.5 L 1823.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1969.5 1237 L 1970 1241.5 L 1969 1241.5 L 1969.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 1961.5 1262 L 1960.5 1264 L 1961.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1957.5 1266 L 1955.5 1269 L 1957.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 1910.5 1268 L 1911.5 1270 L 1910.5 1268 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 292.5 1276 L 801.5 1276 L 803 1277.5 L 802.5 1281 L 802 1277 L 292.5 1277 L 292.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1240.5 1276 L 1749.5 1276 L 1751 1277.5 L 1751 1530.5 L 1749.5 1532 L 1605.5 1532 L 1604 1530.5 L 1605.5 1531 L 1750 1531 L 1750 1277 L 1240.5 1277 L 1240.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 810.5 1299 L 815.5 1305 L 810.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 832.5 1312 L 835 1312.5 L 832.5 1313 L 832.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 1937.5 1313 L 1940 1313.5 L 1937.5 1314 L 1937.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 1907.5 1322 L 1905.5 1325 L 1907.5 1322 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 2004.5 1335 L 2005 1395.5 L 2004 1395.5 L 2004.5 1335 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 1896.5 1343 L 1897 1345.5 L 1896 1345.5 L 1896.5 1343 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1969.5 1346 L 1970 1351.5 L 1969 1351.5 L 1969.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 1896.5 1352 L 1897 1354.5 L 1896 1354.5 L 1896.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 1905.5 1373 L 1908.5 1377 L 1905.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 470.5 1385 L 1569 1385.5 L 470.5 1386 L 470.5 1385 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1928.5 1385 L 1937 1385.5 L 1928.5 1386 L 1928.5 1385 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 449.5 1393 L 443.5 1400 L 449.5 1393 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1589.5 1393 L 1594.5 1399 L 1589.5 1393 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 443.5 1480 L 448.5 1486 L 443.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 1594.5 1481 L 1590.5 1486 L 1594.5 1481 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 596.5 1503 L 591.5 1509 L 596.5 1503 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1451.5 1509 L 1452.5 1511 L 1451.5 1509 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1458.5 1524 L 1459 1526.5 L 1458 1526.5 L 1458.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 434.5 1529 L 435 1530.5 L 433.5 1532 L 292.5 1532 L 292.5 1531 L 433.5 1531 L 434.5 1529 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 583.5 1530 L 584 1532.5 L 583 1532.5 L 583.5 1530 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1458.5 1536 L 1459 1538.5 L 1458 1538.5 L 1458.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 591.5 1554 L 597.5 1561 L 591.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 2005.5 1576 L 2006 1635.5 L 2005 1635.5 L 2005.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 292.5 1604 L 411 1604.5 L 292.5 1605 L 292.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1631 1604 L 1749.5 1604 L 1751 1605.5 L 1750.5 1641 L 1750 1605 L 1632.5 1605 L 1631.5 1606 L 1631 1604 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 1481.5 1648 L 1483.5 1651 L 1481.5 1648 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1486.5 1653 L 1487.5 1655 L 1486.5 1653 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 554.5 1655 L 553.5 1657 L 554.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1495.5 1675 L 1496 1679.5 L 1495 1679.5 L 1495.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 547.5 1681 L 548 1683.5 L 547 1683.5 L 547.5 1681 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 7.5 1699 L 8.5 1701 L 7.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 2071.5 1699 L 2070.5 1701 L 2071.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 1486.5 1701 L 1482.5 1706 L 1486.5 1701 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 13.5 1705 L 14.5 1707 L 13.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 2065.5 1705 L 2064.5 1707 L 2065.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 524.5 1794 L 523.5 1796 L 524.5 1794 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1519.5 1795 L 1522.5 1799 L 1519.5 1795 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 519.5 1799 L 518.5 1801 L 519.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 1524.5 1845 L 1523.5 1847 L 1524.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1518.5 1851 L 1517.5 1853 L 1518.5 1851 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 541.5 1859 L 544 1859.5 L 541.5 1860 L 541.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 380.5 1932 L 1663 1932.5 L 380.5 1933 L 380.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 1750.5 1964 L 1751 1966.5 L 1750 1966.5 L 1750.5 1964 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 1750.5 1970 L 1751 1973.5 L 1750 1973.5 L 1750.5 1970 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 1744.5 1989 L 1743.5 1991 L 1744.5 1989 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 299.5 1991 L 305.5 1998 L 299.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1735.5 1998 L 1734.5 2000 L 1735.5 1998 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 324.5 2005 L 327 2005.5 L 324.5 2006 L 324.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1715.5 2005 L 1719 2005.5 L 1715.5 2006 L 1715.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.5058824"
          stroke="currentColor"
          strokeOpacity="0.5058824"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 1337.5 9 L 1522.5 195 L 1337.5 9 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 583.5 73 L 584 837.5 L 583 837.5 L 583.5 73 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 1350.5 182 L 1407 182.5 L 1350.5 183 L 1350.5 182 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1531.5 215 L 1532 327.5 L 1531 327.5 L 1531.5 215 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 467.5 328 L 473 328.5 L 467.5 329 L 467.5 328 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 1569.5 328 L 1576 328.5 L 1569.5 329 L 1569.5 328 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 1641.5 356 L 1643.5 359 L 1641.5 356 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1647.5 362 L 1649.5 365 L 1647.5 362 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 1677.5 433 L 1678 837.5 L 1677 837.5 L 1677.5 433 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 101.5 861 L 100.5 863 L 101.5 861 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 1949.5 863 L 1950.5 865 L 1949.5 863 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 94.5 867 L 87.5 875 L 94.5 867 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 1963.5 877 L 1964.5 879 L 1963.5 877 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 166.5 911 L 1885 911.5 L 166.5 912 L 166.5 911 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 0.5 1196 L 1 1680.5 L 0 1680.5 L 0.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 2078.5 1197 L 2079 1680.5 L 2078 1680.5 L 2078.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 252.5 1203 L 1790 1203.5 L 252.5 1204 L 252.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 231.5 1212 L 228.5 1216 L 231.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 1907.5 1213 L 1905.5 1216 L 1907.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 1896.5 1237 L 1897 1242.5 L 1896 1242.5 L 1896.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 1904.5 1262 L 1905.5 1264 L 1904.5 1262 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 1959.5 1264 L 1958.5 1266 L 1959.5 1264 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 2004.5 1276 L 2005 1334.5 L 2004 1334.5 L 2004.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1226.5 1304 L 1225.5 1306 L 1226.5 1304 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 835.5 1312 L 838 1312.5 L 835.5 1313 L 835.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 1204.5 1312 L 1208 1312.5 L 1204.5 1313 L 1204.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 1928.5 1313 L 1932 1313.5 L 1928.5 1314 L 1928.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1933.5 1313 L 1937 1313.5 L 1933.5 1314 L 1933.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 1960.5 1325 L 1961.5 1327 L 1960.5 1325 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 1896.5 1346 L 1897 1351.5 L 1896 1351.5 L 1896.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 537.5 1458 L 1505 1458.5 L 537.5 1459 L 537.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 1444.5 1502 L 1445.5 1504 L 1444.5 1502 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 2005.5 1516 L 2006 1575.5 L 2005 1575.5 L 2005.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 1451.5 1553 L 1450.5 1555 L 1451.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1484.5 1651 L 1485.5 1653 L 1484.5 1651 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 547.5 1673 L 548 1680.5 L 547 1680.5 L 547.5 1673 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 555.5 1700 L 560.5 1706 L 555.5 1700 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 9.5 1701 L 12.5 1705 L 9.5 1701 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 2069.5 1701 L 2066.5 1705 L 2069.5 1701 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 522.5 1796 L 520.5 1799 L 522.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 1531.5 1819 L 1532 1821.5 L 1531 1821.5 L 1531.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1531.5 1824 L 1532 1827.5 L 1531 1827.5 L 1531.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 1522.5 1847 L 1519.5 1851 L 1522.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 544.5 1859 L 1499 1859.5 L 544.5 1860 L 544.5 1859 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 1750.5 1967 L 1751 1969.5 L 1750 1969.5 L 1750.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 327.5 2005 L 1715 2005.5 L 327.5 2006 L 327.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'Printer')

export default icon
